export default __webpack_public_path__ + "static/media/BAWSIEDOBRZE.759bd1c6.png";